import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import posthog from "posthog-js"

const TrackPageViews = () => {
  const location = useLocation()

  useEffect(() => {
    posthog.capture("$pageview", { path: location.pathname })
  }, [location.pathname]) // Captura evento cuando cambia la URL

  return null
}

export default TrackPageViews
